import { Component, Input } from '@angular/core';
import { HistoricalStatus } from '../../model/request-detail.model';
import { Translate } from '../../utils/translate';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss'],
  imports: [CommonModule, I18NextModule, MatTableModule]
})
export class TrackingComponent {
  @Input() oldStatus!: HistoricalStatus[];

  constructor(public translate: Translate) {}
}
